import { Link } from 'react-router-dom';

export default function Logo() {
  return (
    <Link to="/" className="focus-ring flex items-center gap-3 rounded-lg" aria-label="Tavio home">
      <span className="grid h-10 w-10 place-items-center rounded-lg border-2 border-ink bg-primary font-display text-lg font-bold text-ink shadow-hard-sm dark:border-ink">
        T
      </span>
      <span>
        <span className="block font-display text-lg font-bold leading-none text-ink dark:text-canvas">Tavio</span>
        <span className="block text-xs font-semibold text-muted dark:text-slate-400">Built for You</span>
      </span>
    </Link>
  );
}
